import React from 'react';
import { Link } from 'react-router-dom';

import RightholdersList from 'rebook/apps/catalog/components/RightholdersList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


// количество блоков которые будут показаны в результатах поиска
const MAX_NUMBER_OF_BLOCKS = 4;

const SearchRightholdersList = ({ rightholdersList, rightholdersCount, query }) => (
  <div className={styles.section}>
    <div className="title-1">Издатели</div>
    {rightholdersCount > MAX_NUMBER_OF_BLOCKS && (
      <Link className="cy-search-all-series"
        to={{
          pathname: `/search/rightholders/`,
          state: { rightholdersList, rightholdersCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {rightholdersCount} {pluralize(rightholdersCount, 'издатель', 'издателя', 'издателей')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      {rightholdersCount > 0 && (
        <RightholdersList rightholders={rightholdersList.slice(0, MAX_NUMBER_OF_BLOCKS)} />
      )}
    </div>
  </div>
);

export default SearchRightholdersList;
